import { Circle } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CircleIcon = createLucideIcon(Circle);
